module.exports = __webpack_public_path__ + "img/matkailukartta.45225de0.svg";